import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'irembogov-expansion-panel-wrapper-with-icon',
  templateUrl: './formly-panel-wrapper.component.html',
  styleUrls: ['formly-panel-wrapper.component.scss'],
})
export class CustomExpansionPanelWithIconComponent extends FieldWrapper {
  constructor() {
    super();
  }
}
